/**
 * Created by dx.yang on 16/4/28.
 */

function switchVisible(el, key, needShow) {
    var state = needShow ? 'show' : 'hide';
    $(el).find('[data-tab-key="' + key + '"]')[state]();
}

export default {
    name: 'KsTabs',
    props: ['value'],
    computed: {
        tabs() {
            return this.value;
        }
    },
    methods: {
        switchTab(tab) {
            var me = this;
            if (tab.disabled) {
                return;
            }
            let tabs = _.cloneDeep(me.value);
            _.forEach(tabs, function(t) {
                t.active = tab.key === t.key;
            });
            me.$emit('input', tabs);
        }
    },
    watch: {
        value: {
            deep: true,
            handler() {
                var me = this;
                _.forEach(me.value, (t) => {
                    switchVisible(me.$el, t.key, t.active);
                }); 
            }
        } 
    },
    mounted() {
        var me = this;
        var curTab = _.find(me.value, 'active');
        if (curTab) {
            switchVisible(me.$el, curTab.key, true);
        }
    }
};

